var map = {
	"./index.js": 52,
	"./module.js": 20,
	"./sp-proximity/sp-proximity.component.js": 95,
	"./sp-proximity/sp-proximity.controller.js": 53,
	"./sp-proximity/sp-proximity.scss": 97,
	"./sp-qr/qr-encode.js": 54,
	"./sp-qr/sp-qr.component.js": 99,
	"./sp-qr/sp-qr.controller.js": 55,
	"./sp-qr/sp-qr.scss": 101,
	"./web-socket.service.js": 102
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;


//////////////////
// WEBPACK FOOTER
// ./src/modules/reverse-ajax \.(js|css|scss)$
// module id = 94
// module chunks = 0 2 3